// GT.chartColors() — resolve the current theme's chart palette from CSS
// custom properties, so ECharts/canvas code follows light/dark automatically
// instead of hard-coding a `getChartColors()` copy per file.
//
// Reads the tokens defined in web/css/tokens.css off :root at call time, so it
// reflects whichever theme (html.light or dark) is active right now. Call it
// again after a theme toggle to re-theme a chart.
export function chartColors(el) {
  const cs = getComputedStyle(el || document.documentElement);
  const v = (name, fallback) => (cs.getPropertyValue(name).trim() || fallback);
  return {
    text: v('--text', '#e2e8f0'),
    muted: v('--muted', '#94a3b8'),
    grid: v('--grid', '#141826'),
    border: v('--border', '#1e2535'),
    accent: v('--accent', '#c8a84b'),
    up: v('--up', '#22c55e'),
    down: v('--down', '#ef4444'),
    bench: v('--bench', '#67e8f9'),
    bg: v('--bg', '#0f1117'),
    bgCard: v('--bg-card', '#141826'),
  };
}

export default chartColors;
